import React from 'react';
import FeatureCards from "../../components/FeatureCards/FeatureCards";
import CTA from "../../components/Constant/cta/CTA";
import TimelineSection from "../../components/TimelineSection/TimelineSection";
import WhySection from "../../components/WhySection/WhySection";
import LocationTimeline from "../../components/LocationTimeline/LocationTimeline";
import IntroSection from "../../components/IntroSection/IntroSection";
import FAQList from "../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../components/Constant/Testimonials/Testimonials";
import DetailsSection from "../../components/DetailsSection/DetailsSection";
import InfoBlocks from "../../components/InfoBlocks/InfoBlocks";
import ServiceCards from "../../components/ServiceCards/ServiceCards";

export default function RealEstateInvestmentItaly() {

    return (
        <main className='main'>
            <IntroSection
                title="Real Estate Investment in Italy"
                subtitle="Secure Residency & Lifestyle in Europe’s Cultural Hub"
                description="Italy offers one of Europe’s most desirable real estate markets, blending lifestyle appeal with long-term property value and multiple residency pathways. While real estate alone does not grant residency, it can be paired with the Investor Visa, Elective Residency Visa, or Italy’s €100k Non-Dom Tax Regime to create a complete relocation, tax, and wealth planning strategy."
                badges={[
                    "Invest in Prime Italian Property",
                    "Residency Pathways",
                    "€100k Non-Dom Tax Regime"
                ]}
                buttonText="Request an Italy Real Estate Consultation →"
                buttonLink="/quote"
                imageSrc={require('../../assets/images/real-estate/real-estate-investment-italy-hero.png')}
                imageAlt="Italy Real Estate Investment"
            />

            <section className='section'>
                <div className="container">

                    <WhySection
                        title="Why Invest in Italian Real Estate?"
                        blocks={[
                            {
                                items: [
                                    { title: "Stable Property Market", text: "High demand in major cities such as Milan, Rome, and Florence." },
                                    { title: "Luxury & Lifestyle Appeal", text: "Tuscany, Lake Como, and the Amalfi Coast attract global luxury buyers." },
                                    { title: "Rental Income", text: "Tourism-driven demand for short-term rentals across Italy." },
                                    { title: "Residency Pathways", text: "Real estate supports Elective Residency and Investor Visa applications." },
                                    { title: "Tax Planning", text: "Combine property investment with Italy’s Non-Dom regime (€100k flat tax)." },
                                    { title: "Citizenship Opportunity", text: "Possible after 10 years of legal residence." }
                                ]
                            }
                        ]}
                    />

                    <InfoBlocks
                        title="Residency Options Linked to Real Estate"
                        blocks={[
                            {
                                head: "Investor Visa for Italy",
                                items: [
                                    { text: "Requires €250,000–€500,000+ investment in companies, bonds, or philanthropic projects." },
                                    { text: "Property ownership strengthens residency intention and ties to Italy." }
                                ]
                            },
                            {
                                head: "Elective Residency Visa",
                                items: [
                                    { text: "Intended for retirees or individuals with passive income." },
                                    { text: "Requires proof of long-term accommodation — property ownership is highly advantageous." }
                                ]
                            },
                            {
                                head: "Non-Dom Tax Regime",
                                items: [
                                    { text: "Relocating to Italy with property supports application approval." },
                                    { text: "Flat €100,000 annual tax on worldwide income for up to 15 years." }
                                ]
                            }
                        ]}
                    />

                    <InfoBlocks
                        title="Best Areas for Real Estate Investment"
                        blocks={[
                            {
                                items: [
                                    { text: "Milan – business, finance, and fashion hub with strong rental demand." },
                                    { text: "Rome – political and cultural capital with a mix of residential and commercial assets." },
                                    { text: "Florence & Tuscany – luxury villas and heritage properties." },
                                    { text: "Lake Como & Northern Lakes – premium vacation homes for global HNWIs." },
                                    { text: "Amalfi Coast & Capri – high-end tourism markets with premium pricing." },
                                    { text: "Sicily & Sardinia – emerging luxury markets with strong seasonal yields." }
                                ]
                            }
                        ]}
                    />

                    <ServiceCards
                        title="Typical Investment Models"
                        services={[
                            { title: "Residential Properties", text: "Apartments, villas, historic buildings, and luxury estates." },
                            { title: "Tourist Rentals", text: "Airbnb and vacation rentals in Italy’s major tourist regions." },
                            { title: "Commercial Real Estate", text: "Offices, retail stores, hotels, and hospitality assets." },
                            { title: "Agricultural Estates", text: "Vineyards, olive groves, and boutique farm properties." }
                        ]}
                    />

                    <WhySection
                        title="Advantages of Italian Property Investment"
                        blocks={[
                            {
                                items: [
                                    { title: "Residency Pathways", text: "Property strengthens multiple visa options." },
                                    { title: "Capital Appreciation", text: "Steady growth across prime Italian cities and luxury destinations." },
                                    { title: "Asset Protection", text: "Real estate can be combined with offshore and trust planning structures." },
                                    { title: "Tax Optimization", text: "The Non-Dom regime provides one of Europe's most attractive tax structures." },
                                    { title: "Lifestyle Benefits", text: "Enjoy Italy’s culture, cuisine, history, and Mediterranean lifestyle." }
                                ]
                            }
                        ]}
                    />


                    <FAQList data={faqData} title='Frequently Asked Questions (FAQ)'/>

                    <CTA
                        title="Looking to invest in Italian property and secure residency?"
                        description="Offshore Advisory provides real estate investment guidance, visa support, and Non-Dom tax planning for a seamless relocation to Italy."
                        buttonText="Book an Italy Real Estate Investment Consultation Today →"
                        buttonLink="/quote"
                    />
                </div>
            </section>
        </main>
    );
};

const faqData = [
    {
        question: "Does buying property in Italy give me residency?",
        content: [
            { type: "answer", text: "Not automatically, but it strengthens Investor Visa or Elective Residency applications." }
        ],
    },
    {
        question: "What is the minimum investment for residency?",
        content: [
            { type: "answer", text: "Investor Visa starts at €250k (not directly tied to property). Golden Visa does not exist in Italy." }
        ],
    },
    {
        question: "Can I rent out my Italian property?",
        content: [
            { type: "answer", text: "Yes, both short-term (Airbnb) and long-term rentals are common." }
        ],
    },
    {
        question: "Can I combine property with the Non-Dom regime?",
        content: [
            { type: "answer", text: "Yes, many HNWIs buy property and move under the €100k flat tax regime." }
        ],
    },
    {
        question: "How long to citizenship?",
        content: [
            { type: "answer", text: "10 years of continuous residence." }
        ],
    },
];


